"use client"

import { useEffect, useRef, type ReactNode } from "react"
import { usePathname } from "next/navigation"
import { useSession } from "next-auth/react"
import { AppStartupLoader } from "@/components/app-startup-loader"
import { isLoginTrackingPage } from "@/lib/analytics/signup-tracking"

/** Login and the authenticated app share `/`; discard the document when tracking scope changes. */
export function LoginTrackingBoundary({ initiallyTracked, children }: {
  initiallyTracked: boolean
  children: ReactNode
}) {
  const pathname = usePathname()
  const { status } = useSession()
  // A server refresh can change props, but it cannot unload already-executed tags.
  const documentTracked = useRef(initiallyTracked)
  const currentlyTracked = isLoginTrackingPage(pathname, status === "unauthenticated")
  const needsReload = status !== "loading" && currentlyTracked !== documentTracked.current

  useEffect(() => {
    if (needsReload) window.location.reload()
  }, [needsReload])

  if (needsReload) return <AppStartupLoader />
  return children
}
